import { useInfiniteQuery } from '@tanstack/react-query'
import { accountKeys } from '../../../../data/queryFactories'
import { showErrorToast } from '../../../../utils/showToast'
import { accountService } from '../../../../service/AccountService'
import { convertUnixToDate } from '../../../../utils/conversion'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'

function mapUserData(data) {
  return {
    uuid: data.uuid || null,
    id: data.schoolId || null,
    name: data.fullName || null,
    accountType: data.accountType || null,
    course: data.course || null,
    groups: data.groups || [],
    schoolEmail: data.schoolEmail || null,
    personalEmail: data.personalEmail || null,
    phoneNumber: data.phoneNumber || null,
    className: data.className || null,
    faculty: data.faculty || null,
    school: data.school || null,
    devices: (data?.devices ?? []).join(', '),
    books: (data?.books ?? []).length,
    status: data.status || null,
    totalPayment: data.totalPayment || 0,
    joinDate: convertUnixToDate(data.joinDate),
  }
}

// SAU mà có thêm nhiều thì nhớ tạo riêng một hook useInfinity với ref và inView ra ngoài nhé
export default function useInfinitySearchAccount({ keyword, pageSize = 8 }) {
  const { ref, inView } = useInView({ threshold: 0 })
  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useInfiniteQuery({
    queryFn: async ({ pageParam = 0 }) => {
      const { success, message } = await accountService.search({
        keyword,
        pageNumber: pageParam,
        pageSize,
      })
      if (!success) {
        throw new Error('Lấy thông tin thất bại')
      }
      if (message && message.content && message.content.users) {
        return {
          pageNumber: message.content.pageNumber,
          totalPages: Math.ceil(message.content.totalItems / pageSize),
          users: (message?.content?.users ?? []).map(mapUserData),
        }
      }
      return { users: [], totalPages: 0 }
    },
    queryKey: accountKeys.list({ keyword }),
    getNextPageParam: (lastPage, allPages) => {
      return lastPage.users.length === pageSize
        ? allPages.length + 1
        : undefined
    },
    initialPageParam: 0,
  })
  if (error) {
    showErrorToast('Lấy thông tin thất bại vui lòng liên hệ admin')
  }

  useEffect(() => {
    if (inView && hasNextPage && !isFetchingNextPage) {
      fetchNextPage()
    }
  }, [inView, hasNextPage, isFetchingNextPage, fetchNextPage])

  return { ref, data, isLoading, fetchNextPage, hasNextPage }
}
